import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function ActionBar({ position = "bottom", children, sx, childrenArrangement = "end", }) {
    return (jsx(Wrapper, { "$childrenArrangement": childrenArrangement, "$position": position, sx: sx, children: children }));
}
const Wrapper = styled("aside")(({ theme, $position, $childrenArrangement }) => (Object.assign({ padding: theme.spacing(2, 4), position: "sticky", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: $childrenArrangement && arrangementToJustifyContentMapper[$childrenArrangement], boxShadow: "0px -1px 1px rgba(112, 144, 176, 0.12), 0px -4px 8px rgba(112, 144, 176, 0.05)", backgroundColor: theme.palette.ui20 }, ($position === "bottom" && {
    bottom: 0,
}))));
const arrangementToJustifyContentMapper = {
    start: "flex-start",
    end: "flex-end",
    "space-between": "space-between",
    "space-around": "space-around",
};

export { ActionBar };
//# sourceMappingURL=ActionBar.js.map
